import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'src/store/store';
import { handleNewUserChange } from 'src/features/company/companySlice';
import { Modal } from 'src/components/new/modal/Modal';
import { ModalTitle } from 'src/components/new/modal/ModalTitle';
import { ModalContent } from 'src/components/new/modal/ModalContent';
import { ModalFooter } from 'src/components/new/modal/ModalFooter';
import { TextField } from 'src/components/new/inputs/TextField';

interface AddNewCompanyUserProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  successMsg?: string;
  errorMsg?: string;
}

const AddNewCompanyUser: React.FC<AddNewCompanyUserProps> = ({ open, onClose, onSubmit }) => {
  const dispatch: AppDispatch = useDispatch();

  const newUser = useSelector((state: RootState) => state.company.newUserForm.value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(handleNewUserChange(e.target.value));
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalTitle onClose={onClose}>Add New User</ModalTitle>
      <ModalContent>
        <TextField id="newUser" value={newUser} name="newUser" onChange={handleChange} error="" label="Email:" />
      </ModalContent>
      <ModalFooter onClose={onClose} closeText="Cancel" onSubmit={() => onSubmit()} submitText="Add" />
    </Modal>
  );
};

export default AddNewCompanyUser;
